import React from 'react';
import { Field } from 'redux-form';
import { createNumberMask, createTextMask } from 'redux-form-input-masks';
import { mmDDYYYY } from '../utils/placeHolderFormat';
import { normalizeDob } from './mask-formats';
import 'animate.css/animate.min.css';

const RenderField = (props) => {
    const style={
        animationDelay: '.5s'
    };
    return (
        //style={style} className="animated zoomIn"
        
        <div style={style} className='form-group animated zoomIn'>
            <LabelControl {...props} />
            <SwitchFormFields {...props} />
        </div>
    )
}

export default RenderField;

const SwitchFormFields = (props) => {
    const {type} = props;
    switch (type) {
        case 'text':
            return (<TextField {...props} />);
        case 'select':
            return (<SelectField {...props} />);
        case 'checkboxlist':
            return (<CheckboxList {...props} />);
        case 'radio':
            return (<RadioListField {...props} />);
        case 'listitem':
            return (<ListItem {...props} />);
        /*
        case 'coverages':
            return (
            <Field
                className='form-control'
                {...input}
                type={type}
                component={CoveragesForm}
            />);
        */
        default:
            return (
                <div>
                    todo
                </div>
            );
    }
}

const LabelControl = (props) => {
    const { label } = props;
    const style={
        animationDelay: '1s'
    };
    return (
        <label >{label}</label>
    );
}

const TextField = (props) => {
    const { label, input, type, name, options, component, placeholder } = props;
    let mask = null;
    //const fieldValue = props.formValues[name];
    //console.log(fieldValue);

    if (placeholder === 'MM/DD/YYYY') {
        mask = normalizeDob;
    }

    //console.log(placeholder);
    return (
        <div>
            <Field
                className='form-control'
                {...input}
                placeholder={placeholder}
                normalize={mask}
                type={type}
                name={name}
                component={component}
            />
        </div>
    );
}

const SelectField = (props) => {
    const { label, input, type, name, options, component } = props;
    return (
        <div>
            <Field
                className='form-control'
                {...input}
                type={type}
                name={name}
                component={component}>
                <option></option>
                {options.map((option, index) => {
                    const { description, code } = option;
                    return (
                        <option key={index}
                            value={code}>{description}</option>
                    )
                })}
            </Field>
        </div>
    );
}

const RadioListField = (props) => {
    const { label, input, type, name, options, component } = props;
    return (
        <div>
            {options.map((option, index) => {
                return (
                    <div
                        className="form-check"
                        key={index}>
                        <label className="form-check-label">
                            <Field
                                className="form-check-input"
                                name={name}
                                input={input}
                                type={type}
                                value={option.code}
                                component={component} />
                            {` ${option.description}`}
                        </label>
                    </div>
                );
            })}
        </div>
    );
}

const CheckboxList = (props) => {
    return (
        <div>
            {JSON.stringify(props)}
            Checkbox list
        </div>
    );
}

const Checkbox = (props) => {
    const { label, input, type, name, options, component } = props;
    return (
        <div>
            {JSON.stringify(props)}
            {options.map(element => {
                return (
                    <div className="form-check">
                        <label>
                            <Field
                                className='form-check-input'
                                {...input}
                                type='checkbox'
                                name={name}
                                component='input'
                            />
                            {` ${element.description}`}
                        </label>
                    </div>
                );
            })}
        </div>
    );
}

const ListItem = (props) => {
    const { label, input, type, name, options, component } = props;
    return (
        <div>
            {JSON.stringify(props)}
            {options.map(element => {
                return (
                    <div className="form-check">
                        <label>
                            {` ${element.description}`}
                        </label>
                    </div>
                );
            })}
        </div>
    );
}


const CoveragesForm = (props) => {
    console.log(props);
    return (
        <div>
            {JSON.stringify(props)}
            Field
        </div>
    )
}




// WEBPACK FOOTER //
// ./src/FieldRenderComponent/index.js